module.exports = __webpack_public_path__ + "static/img/PIPE_EAGLE_SINGLE.8d2ff0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/PIPE_EAGLE_SINGLE.png
// module id = 1633
// module chunks = 6